import { FC } from "react";
import { Link } from "react-router-dom";

import __ from "web/Layout/Translations";

import multisportImg from "web/assets/images/multisport-tile.png";

import urls from "web/constants/urls";

import classes from "./multisportLink.scss";

interface IMultisportLinkProps {
  closeAction?: () => void;
}

const MultisportLink: FC<IMultisportLinkProps> = ({ closeAction }) => {
  return (
    <article className={classes.root} data-t1="autocomplete_product">
      <Link
        to={urls.multisport}
        className={classes.imageBox}
        onClick={closeAction}
        data-t1="autocomplete_product_link_image"
        aria-hidden="true"
        tabIndex={-1}
        aria-label={__("Przejdź do Multisport")}
      >
        <img className={classes.image} src={multisportImg} alt="" />
      </Link>
      <div className={classes.content}>
        <h4 className={classes.name} data-t1="autocomplete_product_title">
          <Link
            className={classes.link}
            to={urls.multisport}
            title="Multisport"
            onClick={closeAction}
            data-t1="autocomplete_product_title_link"
            aria-label={`${__("Przejdź do strony Multisport")}`}
          >
            {__("Multisport")}
          </Link>
        </h4>
        <Link
          className={classes.priceBox}
          to={urls.multisport}
          title="Multisport"
          onClick={closeAction}
          data-t1="autocomplete_product_title_link"
        >
          {__("Sprawdź")}
        </Link>
      </div>
    </article>
  );
};

export default MultisportLink;
